import { render, staticRenderFns } from "./iconCheckBox.vue?vue&type=template&id=40af6cd4&scoped=true&"
import script from "./iconCheckBox.vue?vue&type=script&lang=js&"
export * from "./iconCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./iconCheckBox.vue?vue&type=style&index=0&id=40af6cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40af6cd4",
  null
  
)

export default component.exports